<div class="page-wrapper">
  <div class="fp-container">

    <!-- Header -->
    <div class="login-header">
      <img src="/assets/healthpicks-operator/images/logo.svg" alt="Health Picks" class="logo-img" />
      <h1 class="screen-title">運用者画面</h1>
    </div>

    <!-- Card -->
    <div class="fp-card">

      <div class="success-header">
        <div class="success-icon">
          <img src="assets/healthpicks-operator/images/icon-circel-success.svg" alt="Success" width="40" height="40" />
        </div>
        <h2 class="success-title">ご案内メールをお送りしました</h2>
      </div>

      <div class="info-box-wrapper">
        <div class="info-box">
          <div class="info-box-header">
            <img src="assets/healthpicks-operator/images/icon-question.svg" alt="Info" width="24" height="24" />
            <strong>メールが届かない場合</strong>
          </div>
          <p class="info-box-text">
            dx-utility.comのドメインからメールが届きます。認証メールが届かない場合は、迷惑メールフォルダに入る設定となっていないかご確認ください。
          </p>
        </div>
      </div>

      <div class="fp-footer">
        <button class="btn-outline" (click)="returnToList()">一覧に戻る</button>
      </div>

    </div>

  </div>
</div>
